import { render } from "./AutomationWizardOverviewDescription.vue?vue&type=template&id=44670564&scoped=true"
import script from "./AutomationWizardOverviewDescription.vue?vue&type=script&lang=js"
export * from "./AutomationWizardOverviewDescription.vue?vue&type=script&lang=js"

import "./AutomationWizardOverviewDescription.vue?vue&type=style&index=0&id=44670564&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44670564"]])

export default __exports__